
import { CreatomateFont, BuiltInFontDefinition } from "./BuiltInFonts";

export const CreatomateSantanderFonts: CreatomateFont[] = [
  {
    family: "Santander Text Regular",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-Regular.ttf"
  },
  {
    family: "Santander Text Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-Bold.ttf"
  },
  {
    family: "Santander Text Bold Italic",
    weight: 700,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-BoldItalic.ttf"
  },
  {
    family: "Santander Text Italic",
    weight: 400,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-Italic.ttf"
  },
  {
    family: "Santander Text Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-Light.ttf"
  },
  {
    family: "Santander Text Semibold",
    weight: 600,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderTextSmBd.ttf"
  },
  {
    family: "Santander Text Semibold Italic",
    weight: 600,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderTextSmBdIt.ttf"
  },
  {
    family: "Santander Text Extrabold",
    weight: 800,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderTextXBd.ttf"
  },
  {
    family: "Santander Text Extrabold Italic",
    weight: 800,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderTextXBdIt.ttf"
  },
  {
    family: "Santander Micro Text Regular",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroText.ttf"
  },
  {
    family: "Santander Micro Text Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextBd.ttf"
  },
  {
    family: "Santander Micro Text Bold Italic",
    weight: 700,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextBdIt.ttf"
  },
  {
    family: "Santander Micro Text Italic",
    weight: 400,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextIt.ttf"
  },
  {
    family: "Santander Micro Text Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextLt.ttf"
  },
  {
    family: "Santander Micro Text Light Italic",
    weight: 300,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextLtIt.ttf"
  },
  {
    family: "Santander Micro Text Semibold",
    weight: 600,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextSmBd.ttf"
  },
  {
    family: "Santander Micro Text Semibold Italic",
    weight: 600,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextSmBdIt.ttf"
  },
  {
    family: "Santander Micro Text Extrabold",
    weight: 800,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextXBd.ttf"
  },
  {
    family: "Santander Micro Text Extrabold Italic",
    weight: 800,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextXBdIt.ttf"
  },
  {
    family: "Santander Headline Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadline-Bold.ttf"
  },
  {
    family: "Santander Headline Bold Italic",
    weight: 700,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadline-BoldIt.ttf"
  },
  {
    family: "Santander Headline Italic",
    weight: 400,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadline-It.ttf"
  },
  {
    family: "Santander Headline Regular",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadline-Regular.ttf"
  },
  {
    family: "Santander Headline Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadlineLight.ttf"
  },
  {
    family: "Santander Headline Light Italic",
    weight: 300,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadlineLightIt.ttf"
  }
];

export const BuiltInSantanderFonts: BuiltInFontDefinition[] = [
  {
    family: "Santander Text Regular",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-Regular.ttf"
  },
  {
    family: "Santander Text Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-Bold.ttf"
  },
  {
    family: "Santander Text Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-Light.ttf"
  },
  {
    family: "Santander Text Bold Italic",
    weights: [700],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-BoldItalic.ttf"
  },
  {
    family: "Santander Text Italic",
    weights: [400],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderText-Italic.ttf"
  },
  {
    family: "Santander Text Semibold",
    weights: [600],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderTextSmBd.ttf"
  },
  {
    family: "Santander Text Semibold Italic",
    weights: [600],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderTextSmBdIt.ttf"
  },
  {
    family: "Santander Text Extrabold",
    weights: [800],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderTextXBd.ttf"
  },
  {
    family: "Santander Text Extrabold Italic",
    weights: [800],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderTextXBdIt.ttf"
  },
  {
    family: "Santander Micro Text Regular",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroText.ttf"
  },
  {
    family: "Santander Micro Text Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextBd.ttf"
  },
  {
    family: "Santander Micro Text Bold Italic",
    weights: [700],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextBdIt.ttf"
  },
  {
    family: "Santander Micro Text Italic",
    weights: [400],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextIt.ttf"
  },
  {
    family: "Santander Micro Text Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextLt.ttf"
  },
  {
    family: "Santander Micro Text Light Italic",
    weights: [300],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextLtIt.ttf"
  },
  {
    family: "Santander Micro Text Semibold",
    weights: [600],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextSmBd.ttf"
  },
  {
    family: "Santander Micro Text Semibold Italic",
    weights: [600],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextSmBdIt.ttf"
  },
  {
    family: "Santander Micro Text Extrabold",
    weights: [800],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextXBd.ttf"
  },
  {
    family: "Santander Micro Text Extrabold Italic",
    weights: [800],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderMicroTextXBdIt.ttf"
  },
  {
    family: "Santander Headline Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadline-Bold.ttf"
  },
  {
    family: "Santander Headline Bold Italic",
    weights: [700],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadline-BoldIt.ttf"
  },
  {
    family: "Santander Headline Italic",
    weights: [400],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadline-It.ttf"
  },
  {
    family: "Santander Headline Regular",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadline-Regular.ttf"
  },
  {
    family: "Santander Headline Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadlineLight.ttf"
  },
  {
    family: "Santander Headline Light Italic",
    weights: [300],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Santander/SantanderHeadlineLightIt.ttf"
  }
];
